import { useCallback, useRef, useState } from "react";
import { getCoupons } from "../../../components/coupons/functions";

export function useCouponsSearch(user) {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const lastCodeRef = useRef("");
  const requestIdRef = useRef(0);

  const search = useCallback(
    async (code = "") => {
      if (!user?.token) {
        return;
      }

      const requestId = ++requestIdRef.current;
      lastCodeRef.current = code;
      setLoading(true);
      setError(null);

      const data = await getCoupons(user.token, code || null);

      if (requestId !== requestIdRef.current) {
        return;
      }

      if (data?.type === "error") {
        setError(data);
        setCoupons([]);
      } else if (data?.type === "success") {
        setCoupons(data.data ?? []);
      } else {
        setCoupons([]);
      }

      setLoading(false);
    },
    [user?.token]
  );

  const refresh = useCallback(() => search(lastCodeRef.current), [search]);

  return { coupons, loading, error, search, refresh };
}
